import { type FC, type ReactElement, startTransition, useEffect } from "react"

import { type NavigateFunction, useNavigate } from "react-router-dom"

import { getIndexPage } from "$/utils/get-index-page"

import { type TUserState, useUser } from "@/3514/hooks"
import { ParticipantLayout } from "@/3514/layouts"
import { EUserRole } from "@/3514/types"
import PageLoader from "@/shared/spinner/PageLoader"
import type { TEmptyCallback } from "@/shared/types/functions"

import { SurveysContainer } from "./SurveysContainer"

import "./Surveys.styles.scss"

const Page: FC = (): ReactElement => {
    const { user }: TUserState<EUserRole.Participant> = useUser<EUserRole.Participant>()

    const navigate: NavigateFunction = useNavigate()

    useEffect(
        (): TEmptyCallback => (
            !user.areSurveysPresent && startTransition((): void => void navigate(getIndexPage(user, true))), void 0
        ),
        [user, navigate]
    )

    return user.areSurveysPresent ? (
        <ParticipantLayout>
            <SurveysContainer />
        </ParticipantLayout>
    ) : (
        <PageLoader />
    )
}

export { Page as SurveysPage }
